export const DOWNLOAD = {
  DOWNLOAD_CSV: 'DOWNLOAD_CSV',
  DOWNLOAD_CSV_POST: 'DOWNLOAD_CSV_POST',
  DOWNLOAD_CSV_SUCCESS: 'DOWNLOAD_CSV_SUCCESS',
  DOWNLOAD_CSV_ERROR: 'DOWNLOAD_CSV_ERROR',
};
